<template>
  <Container class="tw-pt-5 tw-text-center">
    <BrandInfo>
      <template #text> You will be redirected.</template>
    </BrandInfo>
  </Container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BrandInfo from 'gpcore-uikit/components/Component.Branding.Info.vue';
import Container from 'gpcore-uikit/components/Component.Container.vue';

export default defineComponent({
  components: {
    BrandInfo,
    Container,
  },
});
</script>
